import { apiFetch } from "@/lib/api";

export type ClampQcCreditSubmittedFilter = "all" | "pending" | "submitted";

export type ClampQcCreditRequestStatus = "draft" | "submitted" | "approved";

export interface ClampQcCreditPurchaseOrderSummaryRow {
  purchaseOrderNumber: string | null;
  purchaseOrderMvId: number | null;
  gipiReceivedDate: string | null;
  purchaseOrderStatus: string | null;
  creditRequestId: number | null;
  creditRequestStatus: ClampQcCreditRequestStatus | null;
  smallCount: number;
  largeCount: number;
  pendingCount: number;
  submittedCount: number;
  totalCount: number;
}

export interface ClampQcCreditRequestsListResponse {
  rows: ClampQcCreditPurchaseOrderSummaryRow[];
  totalCount: number;
  limit: number;
  offset: number;
  summary: {
    pendingCount: number;
    submittedCount: number;
  };
}

export const CLAMP_QC_CREDIT_REQUESTS_QUERY_KEY = ["manufacturing", "clamp-qc-credit-requests"] as const;

export function fetchClampQcCreditRequests(params: {
  submitted: ClampQcCreditSubmittedFilter;
  purchaseOrder: string;
  subtype: "" | "large" | "small";
  limit: number;
  offset: number;
}): Promise<ClampQcCreditRequestsListResponse> {
  const search = new URLSearchParams();
  if (params.submitted !== "all") {
    search.set("submitted", params.submitted);
  }
  if (params.purchaseOrder.trim() !== "") {
    search.set("purchase_order", params.purchaseOrder.trim());
  }
  if (params.subtype !== "") {
    search.set("subtype", params.subtype);
  }
  search.set("limit", String(params.limit));
  search.set("offset", String(params.offset));
  const query = search.toString();
  const path =
    query === ""
      ? "/api/manufacturing/clamp-qc-credit-requests"
      : `/api/manufacturing/clamp-qc-credit-requests?${query}`;
  return apiFetch<ClampQcCreditRequestsListResponse>(path);
}

export function createClampQcCreditRequest(
  purchaseOrderNumber: string,
): Promise<{
  id: number;
  purchaseOrderNumber: string;
  status: ClampQcCreditRequestStatus;
  created: boolean;
}> {
  return apiFetch("/api/manufacturing/clamp-qc-credit-requests/create", {
    method: "POST",
    body: { purchase_order_number: purchaseOrderNumber },
  });
}

export function updateClampQcCreditRequestStatus(
  creditRequestId: number,
  status: ClampQcCreditRequestStatus,
): Promise<{ id: number; status: ClampQcCreditRequestStatus; purchaseOrderNumber: string }> {
  return apiFetch(
    `/api/manufacturing/clamp-qc-credit-requests/${encodeURIComponent(String(creditRequestId))}/status`,
    {
      method: "PATCH",
      body: { status },
    },
  );
}
